/* eslint-disable max-len */
/**
 * Greek translations.
 */
export default {
  ACTION: {
    SAVE: 'Αποθήκευση',
    SUBMIT: 'Υποβολή'
  },
  ERROR: {
    CANCEL_COUNTERPART: 'Σφάλμα κατά την ακύρωση αντισυμβαλλομένου',
    COUNTERPART_DETAILS_SUBMIT: 'Σφάλμα υποβολής αντιγράφου',
    DELETE_ATTACHMENT: 'Σφάλμα διαγραφής συνημμένου',
    DELETE_LINK: 'Σφάλμα διαγραφής συνδέσμου',
    ERROR: 'Σφάλμα',
    FILE_SIZE: 'Το επιλεγμένο αρχείο υπερβαίνει το όριο των 8Mb',
    MAX_FILES_UPLOAD: 'Δεν μπορείτε να υποβάλετε περισσότερα από 8 MB τη φορά',
    PUBLISHED_AT_ERROR: 'Η ημερομηνία δημοσίευσης είναι υποχρεωτική'
  },
  HEADER: {
    APPROVED_BY: 'Εγκρίθηκε από',
    ATTACHMENT: 'Παραρτήματα',
    COMMENT: 'Σχόλιο',
    CONFIRMATION_DATE: 'Επιβεβαίωση',
    CURRENT_PARTNER_TASKS: 'P. Corr',
    DESCRIPTION: 'Περιγραφή',
    END_DATE: 'Ημερομηνία λήξης',
    LINK: 'Σύνδεσμοι',
    MANAGER_COMMENT: 'Σχόλιο διαχειριστή',
    MONTH: 'Μήνας',
    PERIODICITY: 'Συχνότητα',
    PREVIOUS_PARTNER_TASKS: 'P. Ant',
    REQUIRED: 'Απαιτούμενο',
    START_DATE: 'Ημερομηνία έναρξης',
    STATE: 'Κράτος',
    SUBMISSION_DATE: 'Υποβολή'
  },
  LABEL: {
    ATTACHMENTS: 'Παραρτήματα',
    ATTACHMENTS_UPLOADED: 'Ανεβασμένα συνημμένα αρχεία',
    CANCEL_COUNTERPART: 'Ακύρωση',
    CLOSE: 'Κλείστε το',
    COMMENT: 'Σχόλιο',
    CONFIRM: 'Επιβεβαίωση',
    DESCRIPTION: 'Περιγραφή',
    FILTER_MONTH_APR: 'Απρίλιος',
    FILTER_MONTH_AUG: 'Αύγουστος',
    FILTER_MONTH_DEC: 'Δεκέμβριος',
    FILTER_MONTH_FEB: 'Φεβρουάριος',
    FILTER_MONTH_JAN: 'Ιανουάριος',
    FILTER_MONTH_JUL: 'Ιούλιος',
    FILTER_MONTH_JUN: 'Ιούνιος',
    FILTER_MONTH_MAR: 'Μάρτιος',
    FILTER_MONTH_MAY: 'Μάιος',
    FILTER_MONTH_NOV: 'Νοέμβριος',
    FILTER_MONTH_OCT: 'Οκτώβριος',
    FILTER_MONTH_SEP: 'Σεπτέμβριος',
    LINK: 'Σύνδεσμος',
    LINKS: 'Σύνδεσμοι',
    LINKS_UPLOADED: 'Ανεβασμένοι σύνδεσμοι',
    MONTH: 'Μήνας',
    PUBLISHED_AT: 'Ημερομηνία δημοσίευσης',
    STATE: 'Κράτος',
    SUBMIT_COUNTERPART: 'Υποβολή',
    YEAR: 'Έτος'
  },
  SENTENCE: {
    CANCEL_COUNTERPART_TEXT:
      'Είστε σίγουρος ότι θέλετε να ακυρώσετε την υποβολή αντιγράφου;',
    CONFIRM_SUBMIT_COUNTERPART_TEXT:
      'Είστε σίγουρος ότι θέλετε να υποβάλετε το αντίγραφο;',
    NO_ROWS_ATTACHMENT: 'Δεν υπάρχουν συνημμένα'
  },
  SUCCESS: {
    ATTACHMENT_DELETED: 'Παράρτημα διαγράφεται',
    CANCEL_COUNTERPART: 'Ομόλογος ακυρώθηκε',
    COUNTERPART_DETAILS_SUBMIT: 'Υποβληθέντα στοιχεία αντισυμβαλλομένου',
    LINK_DELETED: 'Διαγραφή συνδέσμου',
    SUCCESS: 'Επιτυχία'
  },
  TOOLTIP: {
    ADD_LINK: 'Νέος σύνδεσμος',
    APPROVED_BY: 'Αντιστοίχιση που εγκρίθηκε από',
    ATTACHMENT: 'Παραρτήματα',
    COMMENT: 'Σχόλιο',
    CONFIRMATION_DATE: 'Ημερομηνία επιβεβαίωσης αντισυμβαλλομένου',
    CURRENT_PARTNER_TASKS:
      'Αριθμός εγγραφών για την τρέχουσα περίοδο που πρέπει να υποβληθούν από τον εταίρο',
    DESCRIPTION: 'Περιγραφή',
    END_DATE: 'Ημερομηνία λήξης',
    LINK: 'Σύνδεσμοι',
    MANAGER_COMMENT: 'Σχόλιο του διαχειριστή',
    MONTH: 'Μήνας',
    PERIODICITY: 'Συχνότητα',
    PREVIOUS_PARTNER_TASKS:
      'Αριθμός εγγραφών από την προηγούμενη περίοδο που πρέπει να υποβληθούν από τον εταίρο',
    REMOVE_LINK: 'Αφαίρεση συνδέσμου',
    REQUIRED: 'Απαιτούμενο',
    START_DATE: 'Ημερομηνία έναρξης',
    STATE: 'Κράτος',
    SUBMISSION_DATE: 'Ημερομηνία υποβολής αντιτίμου'
  }
};
